export default __webpack_public_path__ + "static/media/welpentreffen_41.72f5f082.jpg";